import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Checkbox from "./checkbox";
import ErrorMessage from "./errormessage";
import Form from "./form";
import Input from "./input";
import P from "./p";
import Page from "./page";
import PageHeader from "./pageheader";
import { Loader } from "../shared";

function PartnerForm({ application, mediaQuery }) {
  const nextUrl = "/apply/review/";
  const submitUrl = "/api/applications/v4/application/partner/";
  const {
    submission: { partner }
  } = application;
  const [form, setForm] = useState({
    errors: {},
    ...partner
  });
  return (
    <Form form={form} setForm={setForm} nextUrl={nextUrl} showBack={true} submitUrl={submitUrl}>
      <div style={{ margin: "1rem" }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
          <Input
            type="text"
            name="first_name"
            value={form?.first_name || ""}
            maxLength="256"
            placeholder="First name"
            form={form}
            setForm={setForm}
            style={{ gridColumn: mediaQuery.isTabletOrMobile ? "span 2" : "" }}
          />
          <Input
            type="text"
            name="last_name"
            value={form?.last_name || ""}
            maxLength="256"
            placeholder="Last name"
            form={form}
            setForm={setForm}
            style={{ gridColumn: mediaQuery.isTabletOrMobile ? "span 2" : "" }}
          />
          <Input
            type="tel"
            name="mobile_phone"
            value={form?.mobile_phone || ""}
            maxLength="64"
            placeholder="Mobile phone number"
            form={form}
            setForm={setForm}
            style={{ gridColumn: mediaQuery.isTabletOrMobile ? "span 2" : "" }}
          />
          <Input
            type="email"
            name="email"
            value={form?.email || ""}
            maxLength="255"
            placeholder="Email address"
            form={form}
            setForm={setForm}
            style={{ gridColumn: mediaQuery.isTabletOrMobile ? "span 2" : "" }}
          />
          <Checkbox
            name="not_interested"
            label="My partner is not currently interested in joining"
            form={form}
            setForm={setForm}
            style={{ gridColumn: "span 2" }}
          />
        </div>
      </div>
    </Form>
  );
}

export default function PartnerPage({ mediaQuery, page, total }) {
  const { isLoading, error, data } = useQuery(["application"]);
  const {
    results: [application]
  } = data;
  return (
    <Page>
      <PageHeader title={`APPLICATION PAGE ${page} OF ${total}`} tagline="Invite Your Partner">
        <P style={{ marginBottom: "1rem" }}>
          Is your partner interested in joining The Battery as well? If you&apos;re both accepted,
          they will qualify for the partner rate of $1,600 per year and $1,000 initiation fee. To
          qualify as a partner, they must live in the same household as you.
        </P>
      </PageHeader>
      {isLoading || application === undefined ? (
        <Loader loading={isLoading} />
      ) : (
        <PartnerForm application={application} mediaQuery={mediaQuery} />
      )}
      {error ? <ErrorMessage error={error} /> : null}
    </Page>
  );
}
